import React, { useEffect } from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ReframeSection } from './components/ReframeSection';
import { PhasesSection } from './components/PhasesSection';
import { TimelineSection } from './components/TimelineSection';
import { ProductSection } from './components/ProductSection';
import { TransformationSection } from './components/TransformationSection';
import { BonusesSection } from './components/BonusesSection';
import { FitSection } from './components/FitSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CloseCTASection } from './components/CloseCTASection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1
    });
    reveals.forEach(el => observer.observe(el));
    return () => {
      reveals.forEach(el => observer.unobserve(el));
    };
  }, []);
  return <div className="min-h-screen" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <PainSection data-id="element-3" />
      <ReframeSection data-id="element-4" />
      <PhasesSection data-id="element-5" />
      <TimelineSection data-id="element-6" />
      <ProductSection data-id="element-7" />
      <TransformationSection data-id="element-8" />
      <BonusesSection data-id="element-9" />
      <TestimonialsSection data-id="element-10" />
      <PricingSection data-id="element-11" />
      <GuaranteeSection data-id="element-12" />
      <FAQSection data-id="element-13" />
      <CloseCTASection data-id="element-14" />
      <Footer data-id="element-15" />
      <SocialProofPopup data-id="element-16" />
    </div>;
}